'use strict';
module.exports = ([function () {
        return function (zonedDateTime, format) {
            
            //moment($scope.curSituationRecord.createdDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").toDate();
            
            var ret = undefined;
            if (!format){
                format="YYYY-MM-DDTHH:mm:ss.SSSZ";
            };
            if (zonedDateTime && zonedDateTime!==null){
                ret=moment(zonedDateTime, format).toDate();
            };            
            return ret;
        };
    }]);






//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/zonedDateTimeToDateFilter.js
// module id = 277
// module chunks = 0